
import HttpErrorMixin from "./HttpErrorMixin";
import {message} from '@grininc/grin-ui'

export default {
    mixins: [
        HttpErrorMixin
    ],
    data() {
        return {
            errorMessage: null,
            errors: {},
            isLoading: false,
        }
    },
    props: {
        tag: {
            type: String,
            default: 'div',
        }
    },
    methods: {
        handleHttpError(error, handleConflict) {
            if (error.status === 422) {
                this.errors = error.data.errors;
                this.errorMessage = error.data.message;
            } else if (error.status === 409) {
                if (handleConflict) {
                    handleConflict(error);
                } else {
                    this.handleGenericError(error);
                }
            } else if (error.status === 423) {
                return this.handleLockedException(error.data);
            } else {
                this.handleGenericError(error);
            }
        },
        handleGenericError(error) {
            console.log(error);
            message.error('Something went wrong, please try again or contact support');
        },

        resetErrors() {
            this.errorMessage = null;
            this.errors = {};
        },
    }
}
